import { observer } from 'mobx-react';

import { store } from '@store';
import { translate } from '@chaika/i18n/helper';
import { WarningBanner } from '@components/WarningBanner';

import { useHasForeignDraftEntries } from './queries/draftEntriesQueries';
import { resolveAssignedDoctorIds } from './utils/resolveAssignedDoctorIds';
import { useDraftEntriesBannerDismissal } from './hooks/useDraftEntriesBannerDismissal';

export const DraftEntriesBanner = observer(() => {
    const { authUser } = store;

    const doctorIds = resolveAssignedDoctorIds(authUser);

    const { data: hasDrafts } = useHasForeignDraftEntries(doctorIds, authUser.id);
    const { isDismissed, dismiss } = useDraftEntriesBannerDismissal();

    if (!hasDrafts || isDismissed) {
        return null;
    }

    return <WarningBanner onClose={dismiss}>{translate('newDraftEntriesNotification')}</WarningBanner>;
});
